import React from 'react';
import {PUBLIC_WEB_SIGN_IN_PAGE} from "../../const/route/Route";

const App = () => {
  return window.location.href = PUBLIC_WEB_SIGN_IN_PAGE; // temporary added
  const urlParams = new URLSearchParams(window.location.search);
  const event_id = urlParams.get('e');
  if(event_id !== undefined && event_id !== ""){
    window.location.href = "https://link.tags.lk/?link=https%3A%2F%2Ftags.lk%2Fevent-app%2F%3Fevent_id%3D" + event_id + "&apn=com.ceyentra.tags&ibi=com.ceyentra.tags&isi=1469203062&ius=app-1-938968550560-ios-9dc5f8cb7c4f22a1d20dc5&ipbi=com.ceyentra.tags";
    // link=https%3A%2F%2Ftags.lk%2Fsmart-app%2F%3Fevent_id%3D81&apn=com.ceyentra.tags&ibi=com.ceyentra.tags&isi=1533379541&ius=app-1-938968550560-ios-3c2b0b0ea2b1e434d20dc5&ipbi=com.ceyentra.tags //old
    // link=https%3A%2F%2Ftags.lk%2Fsmart-app%2F%3Fevent_id%3D80&apn=com.ceyentra.tags&ibi=com.ceyentra.tags&isi=1469203062&ius=app-1-938968550560-ios-9dc5f8cb7c4f22a1d20dc5&ipbi=com.ceyentra.tags //new
    // window.location.replace("https://eventtags.dialog.lk/view/?e=26";
    // https://event-link.tags.lk/?link=https%3A%2F%2Ftags.lk%2F%3Fevent_id%3D3&apn=com.ceyentra.eventtags&ibi=com.ceyentra.eventtags
    // https://event-link.tags.lk/?link=https%3A%2F%2Ftags.lk%2F%3Fevent_id%3D
    // https://event-link.tags.lk/?link=https%3A%2F%2Ftags.lk%2Fevent-app%2F%3Fevent_id%3D
  }else{
    window.location.replace(window.location.origin);
  }
};
export default App;
